
  import FaqPanel from '@/components/elements/FaqPanel';
  export default {
    name: 'SectionFaqs',
    components: {
      FaqPanel,
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    jsonld() {
      const faqQuestions = [];
      for (const key in this.section.elements) {
        if (key === 'hydra:view') {
          continue;
        }

        const element = this.section.elements[key];
        faqQuestions.push({
          '@type': 'Question',
          name: element.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: element.answer,
          },
        });
      }
      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqQuestions,
      };
    },
  };
